import styled from 'styled-components';
import { onPhone, toneOf } from '../theme/tokens';

const TonePill = styled.span`
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  padding: 1px 9px;
  background: ${(p) => toneOf(p.$tone).bg};
  color: ${(p) => toneOf(p.$tone).fill};
  ${onPhone} {
    font-size: 12px;
  }
`;

export default TonePill;
